import styled from 'styled-components';

export const ProgressSpinnerContainer = styled.div`
    padding: 50px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
`;
